var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g2, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g3, _path58, _path59;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstallation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 728,
    viewBox: "0 0 725 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_91_1769",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -47,
    y: -49,
    width: 803,
    height: 816
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M756 -49H-47V767H756V-49Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_91_1769)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M720.399 254.949C713.898 168.989 656.057 96.6011 584.275 53.2839C514.947 11.4654 431.709 -6.7674 351.269 2.25841C239.902 14.743 91.5321 86.1423 99.2354 217.642C100.634 241.426 107.317 265.192 103.828 288.761C97.5399 331.273 60.8673 361.463 36.4243 396.792C10.5822 434.129 -2.32235 480.231 0.344143 525.558C3.33986 576.336 29.6757 629.189 76.8334 648.163C124.156 667.187 177.502 648.278 228.462 650.173C311.009 653.236 382.198 710.438 463.575 724.652C523.555 735.144 587.485 720.683 637.111 685.402C660.321 668.9 680.831 647.454 691.562 621.069C718.573 554.644 677.999 479.045 688.681 408.124C696.039 359.354 722.161 316.762 720.96 266.28C720.861 262.475 720.68 258.704 720.399 254.949Z",
    fill: "#DFFF02",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M673.433 266.564C667.634 189.815 616.052 125.183 552.035 86.5066C490.207 49.1687 415.974 32.8894 344.236 40.9482C244.918 52.0951 112.598 115.845 119.468 233.255C120.716 254.49 126.676 275.71 123.564 296.754C117.956 334.711 85.251 361.667 63.4523 393.21C40.4059 426.547 28.8974 467.709 31.2754 508.18C33.947 553.518 57.4338 600.707 99.4898 617.649C141.693 634.634 189.268 617.752 234.715 619.443C308.331 622.178 371.819 673.252 444.392 685.942C497.884 695.31 554.898 682.399 599.155 650.898C619.854 636.164 638.145 617.016 647.716 593.458C671.804 534.15 635.619 466.65 645.146 403.328C651.708 359.783 675.004 321.755 673.933 276.682C673.844 273.285 673.683 269.917 673.433 266.564Z",
    fill: "#DFFF02",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M621.519 282.143C616.659 217.673 573.419 163.383 519.757 130.895C467.929 99.5308 405.702 85.8562 345.568 92.6255C262.313 101.989 151.395 155.538 157.154 254.163C158.2 272.001 163.196 289.826 160.587 307.503C155.887 339.386 128.471 362.029 110.198 388.526C90.8795 416.529 81.2324 451.105 83.2258 485.1C85.4653 523.184 105.153 562.823 140.407 577.054C175.784 591.322 215.664 577.14 253.761 578.561C315.47 580.859 368.689 623.76 429.524 634.421C474.364 642.29 522.156 631.444 559.256 604.983C576.607 592.607 591.939 576.523 599.962 556.734C620.154 506.915 589.822 450.215 597.808 397.025C603.309 360.447 622.837 328.504 621.939 290.642C621.864 287.788 621.729 284.96 621.519 282.143Z",
    fill: "#DFFF02",
    fillOpacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M491 124C484.373 124 479 118.627 479 112V86C479 79.3726 473.627 74 467 74H414C407.373 74 402 79.3726 402 86V92C402 98.6274 396.627 104 390 104H375C368.373 104 363 109.373 363 116V172C363 178.627 368.373 184 375 184H502C508.627 184 514 178.627 514 172V136C514 129.373 508.627 124 502 124H491Z",
    fill: "#22420D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M700.193 711.668H720.397",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10767 711.668H688.741",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256.253 348.755V235.867",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M338.162 147.956H354.222",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M444.16 189.712V227.406",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M331.947 344.982H229.611V447.316H331.947V344.982Z",
    fill: "#97EC5F",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M327.193 349.736H234.381V442.548H327.193V349.736Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.66 380.989L284.011 403.618L267.147 398.897C265.461 398.431 263.662 398.751 262.249 399.78L234.353 420.016V442.581H327.165V394.849L313.884 381.005C311.635 378.661 307.876 378.661 305.629 381.005L305.66 380.989Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M279.635 379.142C282.092 373.16 279.233 366.321 273.251 363.864C267.269 361.409 260.429 364.268 257.974 370.249C255.519 376.231 258.377 383.07 264.357 385.525C270.339 387.982 277.18 385.124 279.635 379.142Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M261.459 382.755H168.02V258.818H220.151L261.459 300.126V382.755Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_91_1769",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 258,
    width: 94,
    height: 125
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M261.459 382.755H168.02V258.818H220.151L261.459 300.126V382.755Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_91_1769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.491 300.399V316.265C257.251 304.895 220.184 300.399 220.184 300.399H261.491Z",
    fill: "#DFFF02"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M261.491 300.399V316.265C257.251 304.895 220.184 300.399 220.184 300.399H261.491Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M261.459 382.755H168.02V258.818H220.151L261.459 300.126V382.755Z",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M261.458 300.126H220.152V258.818L261.458 300.126Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M191.611 315.704H237.864",
    stroke: "#212121",
    strokeWidth: 5.19412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.611 328.439H237.864",
    stroke: "#212121",
    strokeWidth: 5.19412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M191.611 341.161H237.864",
    stroke: "#212121",
    strokeWidth: 5.19412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M222.721 355.034H164.855V385.87H222.721V355.034Z",
    fill: "#97EC5F",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M182.266 375.527V377.599H180.193V375.527H182.266Z",
    fill: "#212121"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M190.203 367.304V369.088C190.203 371.271 189.141 372.476 186.989 372.476H185.978V377.615H183.826V363.932H186.989C189.141 363.932 190.203 365.119 190.203 367.32V367.304ZM185.978 365.874V370.516H186.989C187.68 370.516 188.05 370.211 188.05 369.231V367.176C188.05 366.196 187.68 365.892 186.989 365.892H185.978V365.874Z",
    fill: "#212121"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M191.198 363.915H194.602C196.754 363.915 197.815 365.104 197.815 367.303V374.225C197.815 376.41 196.754 377.615 194.602 377.615H191.198V363.932V363.915ZM193.35 365.874V375.655H194.555C195.244 375.655 195.646 375.302 195.646 374.322V367.208C195.646 366.228 195.228 365.874 194.555 365.874H193.35Z",
    fill: "#212121"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M201.33 370.002H204.109V371.962H201.33V377.615H199.178V363.932H204.864V365.892H201.33V370.019V370.002Z",
    fill: "#212121"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M483.649 138.542H442.598V179.592H483.649V138.542Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M481.757 140.453H444.511V177.696H481.757V140.453Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M473.115 152.978L464.427 162.053L457.666 160.157C456.991 159.965 456.269 160.093 455.706 160.511L444.511 168.621V177.679H481.757V158.535L476.424 152.978C475.524 152.031 474.016 152.031 473.115 152.978Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M462.641 152.236C463.627 149.832 462.48 147.083 460.075 146.096C457.671 145.109 454.922 146.258 453.935 148.662C452.948 151.066 454.096 153.815 456.501 154.802C458.904 155.789 461.654 154.64 462.641 152.236Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M455.367 153.705H417.898V103.982H438.81L455.367 120.556V153.705Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_91_1769",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 417,
    y: 103,
    width: 39,
    height: 51
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M455.366 153.705H417.897V103.982H438.809L455.366 120.556V153.705Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_91_1769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.383 120.67V127.03C453.681 122.469 438.81 120.67 438.81 120.67H455.383Z",
    fill: "#DFFF02"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M455.383 120.67V127.03C453.681 122.469 438.81 120.67 438.81 120.67H455.383Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M455.367 153.705H417.898V103.982H438.81L455.367 120.556V153.705Z",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M455.37 120.556H438.813V103.982L455.37 120.556Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M427.36 126.805H445.91",
    stroke: "white",
    strokeWidth: 5.19412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M427.36 131.911H445.91",
    stroke: "white",
    strokeWidth: 5.19412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M427.36 137.02H445.91",
    stroke: "white",
    strokeWidth: 5.19412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M439.838 142.576H416.615V154.942H439.838V142.576Z",
    fill: "#97EC5F",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M423.597 150.797V151.632H422.762V150.797H423.597Z",
    fill: "#212121"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M426.791 147.505V148.212C426.791 149.095 426.374 149.577 425.506 149.577H425.104V151.633H424.239V146.14H425.506C426.374 146.14 426.791 146.622 426.791 147.505ZM425.089 146.927V148.79H425.491C425.764 148.79 425.908 148.662 425.908 148.276V147.457C425.908 147.072 425.764 146.943 425.491 146.943H425.089V146.927Z",
    fill: "#212121"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M427.179 146.14H428.543C429.41 146.14 429.828 146.622 429.828 147.505V150.284C429.828 151.167 429.41 151.649 428.543 151.649H427.179V146.156V146.14ZM428.046 146.927V150.846H428.527C428.801 150.846 428.96 150.701 428.96 150.316V147.457C428.96 147.072 428.801 146.927 428.527 146.927H428.046Z",
    fill: "#212121"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M431.243 148.581H432.352V149.369H431.243V151.633H430.376V146.14H432.658V146.927H431.243V148.581Z",
    fill: "#212121"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M369.171 271.442H656.827C666.559 271.442 674.461 279.344 674.461 289.076V548.61H351.553V289.076C351.553 279.344 359.455 271.442 369.187 271.442H369.171Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M656.842 271.442H442.645V321.26H674.476V289.058C674.476 279.326 666.589 271.424 656.842 271.424V271.442Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M656.842 271.442H369.187C359.455 271.442 351.553 279.328 351.553 289.076V301.876H674.461V289.076C674.461 279.344 666.574 271.442 656.827 271.442H656.842Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M631.064 291.997C633.725 291.997 635.882 289.839 635.882 287.18C635.882 284.519 633.725 282.361 631.064 282.361C628.402 282.361 626.245 284.519 626.245 287.18C626.245 289.839 628.402 291.997 631.064 291.997Z",
    fill: "#97EC5F",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M646.064 291.997C648.725 291.997 650.882 289.839 650.882 287.18C650.882 284.519 648.725 282.361 646.064 282.361C643.403 282.361 641.246 284.519 641.246 287.18C641.246 289.839 643.403 291.997 646.064 291.997Z",
    fill: "#97EC5F",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M661.053 291.997C663.714 291.997 665.871 289.839 665.871 287.18C665.871 284.519 663.714 282.361 661.053 282.361C658.393 282.361 656.236 284.519 656.236 287.18C656.236 289.839 658.393 291.997 661.053 291.997Z",
    fill: "#97EC5F",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M283.14 506.725L276.618 497.428L248.609 537.305H262.374V565.779H273.647",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M279.626 565.777H290.852V537.303H304.617L285.407 509.952",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M115.947 425.876L98.4744 401L81 425.876H89.5923V443.656H107.355V425.876H115.947Z",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M592.271 93.9757L602.1 79.9711H593.507V62.1925H575.727V79.9711H567.136L584.625 104.849L588.881 98.7776",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M712.465 464.164L723.609 448.281H715.034V430.501H707.871",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M702.346 430.501H697.255V448.281H688.663L706.136 473.157L709.237 468.74",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M134.053 157.848H140.076V140.085H148.652L131.179 115.192L113.705 140.085H122.297V157.848H129.46",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M416.615 266.802L444.625 306.679L472.618 266.802H458.853V238.326H430.379V266.802H416.615Z",
    fill: "#97EC5F",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_91_1769",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 463,
    y: 382,
    width: 98,
    height: 98
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M560.839 382.977H463.882V479.934H560.839V382.977Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_91_1769)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.359 391.055V417.315C512.359 418.922 512.996 420.463 514.133 421.6C515.269 422.736 516.81 423.375 518.418 423.375H544.677V463.773C544.677 465.916 543.826 467.972 542.311 469.486C540.795 471.001 538.74 471.853 536.598 471.853H488.119C485.976 471.853 483.921 471.001 482.406 469.486C480.891 467.972 480.039 465.916 480.039 463.773V399.136C480.039 396.992 480.891 394.937 482.406 393.422C483.921 391.907 485.976 391.055 488.119 391.055H512.359ZM518.786 438.149L508.787 448.147L505.93 445.29C505.168 444.555 504.148 444.148 503.089 444.156C502.029 444.165 501.016 444.591 500.267 445.339C499.519 446.089 499.093 447.102 499.084 448.161C499.076 449.221 499.482 450.24 500.218 451.002L505.644 456.432C506.056 456.846 506.546 457.173 507.087 457.396C507.625 457.62 508.203 457.736 508.787 457.736C509.37 457.736 509.949 457.62 510.489 457.396C511.027 457.173 511.517 456.846 511.929 456.432L524.497 443.86C524.883 443.488 525.192 443.041 525.403 442.55C525.616 442.056 525.727 441.527 525.732 440.99C525.735 440.453 525.633 439.922 525.431 439.425C525.228 438.928 524.927 438.478 524.548 438.098C524.168 437.719 523.718 437.418 523.221 437.215C522.724 437.013 522.193 436.911 521.656 436.914C521.119 436.919 520.59 437.03 520.096 437.243C519.604 437.454 519.158 437.762 518.786 438.149ZM520.437 391.228C521.968 391.554 523.372 392.316 524.478 393.422L542.31 411.255C543.416 412.36 544.18 413.764 544.503 415.294H520.437V391.228Z",
    fill: "#212121"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M308 122C301.373 122 296 116.627 296 110V84.0001C296 77.3727 290.627 72.0001 284 72.0001H231C224.373 72.0001 219 77.3727 219 84.0001V90.0001C219 96.6275 213.627 102 207 102H192C185.373 102 180 107.373 180 114V170C180 176.627 185.373 182 192 182H319C325.627 182 331 176.627 331 170V134C331 127.373 325.627 122 319 122H308Z",
    fill: "#22420D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M284.189 174.856L256.179 134.995L228.186 174.856H241.95V203.331H270.425V174.856H284.189Z",
    fill: "#97EC5F",
    stroke: "#212121",
    strokeWidth: 1.73137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.2d6f23b8f629665007ec5682bd5223ba.svg";
export { ForwardRef as ReactComponent };